import React from 'react';
import { useSelector } from 'react-redux';

import PageHeader from '@uikit/old/PageHeader/PageHeader';
import Profile from '@components/Settings/Profile/Profile';
import Loader from '@uikit/old/Loader/Loader';
import { checkIsAnyNotLoaded } from '@utils/loadingChecks';

import { userProfileSelector } from '@redux/selectors/userProfile.selector';

import './ProfileSettings.css';

const ProfileSettings = () => {
  const { info: profile, loadingStatus: profileLs } = useSelector(userProfileSelector);

  return (
    <div className="settings-profile">
      <PageHeader title="Profile" />
      <Loader isLoading={checkIsAnyNotLoaded(profileLs)} withTopMargin>
        <Profile profile={profile} />
      </Loader>
    </div>
  );
};

export default ProfileSettings;
